module.exports = __webpack_public_path__ + "img/tools_2_768.37f1f5b.jpg";